var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4688 5.5H10.6562V4.33203C10.6562 2.30078 9.03125 0.650391 7 0.625C4.96875 0.625 3.34375 2.27539 3.34375 4.28125V5.5H2.53125C1.8457 5.5 1.3125 6.05859 1.3125 6.71875V12.4062C1.3125 13.0918 1.8457 13.625 2.53125 13.625H11.4688C12.1289 13.625 12.6875 13.0918 12.6875 12.4062V6.71875C12.6875 6.05859 12.1289 5.5 11.4688 5.5ZM4.5625 4.28125C4.5625 2.96094 5.6543 1.84375 7 1.84375C8.32031 1.84375 9.4375 2.96094 9.4375 4.28125V5.5H4.5625V4.28125ZM11.4688 12.4062H2.53125V6.71875H11.4688V12.4062Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.8568bbfd6366a1423c36aca8efc18cf9.svg";
export { ForwardRef as ReactComponent };